// extracted by mini-css-extract-plugin
export default {"container":"Unauthorized_container__OP04U","heading":"Unauthorized_heading__1A3Lu","link":"Unauthorized_link__n9tEI","goto":"Unauthorized_goto__E6fpr"};